KXL.module('Components.Ticker', function(Ticker, KXL, Backbone, Marionette, $, _) {
	Ticker.Controller = {
		getTicker: function () {
			return new Ticker.View();
		}
	};
});
